import React from 'react';

import Box from '@mui/material/Box';

import { KnzInlineProps } from '../../types';

/** ロールカラー（tech_design のロールカラー固定値） */
const ROLE_COLORS: Record<string, string> = {
  ADMIN: '#d32f2f',
  GENERAL: '#1976d2',
  MANAGER: '#388e3c',
};

/**
 * インラインの小さなラベル（`{{badge:実験中}}`）。
 * value が ADMIN/GENERAL/MANAGER の場合はロールカラーを適用する。
 * `label|color` 形式で任意のテーマトークン色も指定できる（例: `{{badge:重要|error.main}}`）。
 */
export const BadgeInline: React.FC<KnzInlineProps> = ({ value }) => {
  const [label, colorToken] = value.split('|').map((s) => s.trim());
  const roleColor = ROLE_COLORS[label];
  const color = roleColor ?? colorToken ?? 'primary.main';

  return (
    <Box
      component="span"
      sx={{
        display: 'inline',
        whiteSpace: 'nowrap',
        verticalAlign: 'baseline',
        px: 0.75,
        py: 0.1,
        mx: 0.25,
        fontSize: '0.72em',
        fontWeight: 700,
        lineHeight: 1.6,
        borderRadius: 1,
        color: roleColor ? '#fff' : color,
        bgcolor: roleColor ? roleColor : 'action.selected',
      }}
    >
      {label}
    </Box>
  );
};

export default BadgeInline;
